import { useMutation, useQueryClient } from '@tanstack/react-query';
import { logout } from 'api/auth.service';
import { AxiosError } from 'axios';
import { useToast } from 'hooks/ui';
import { useNavigate } from 'react-router-dom';
import { removeCurrentUser } from 'store/user.store';

export const useAdminLogout = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isLoading, mutate } = useMutation(logout, {
    onSuccess: () => {
      queryClient.clear();
      removeCurrentUser();
      navigate('/login');
    },
    onError: (error: AxiosError) => {
      toast.error(error.message);
    },
  });

  return { isLoading, mutate };
};
